const api_url = "/api";
//const api_url = "http://localhost:5000/api"

export const uploadProduct = async (item) => {
    const formData = new FormData();

    formData.append("productName", item.productName);
    formData.append("description", item.description);
    formData.append("sizes", JSON.stringify(item.sizes));
    formData.append("category", item.category);
    formData.append("price", item.price);
    formData.append("quantity", item.quantity);

    if (item.mainImage) {
    formData.append("mainImage", item.mainImage);
   }

   item.subImages.forEach((image) => {
    formData.append("subImages", image);
  });

  const response = await fetch(`${api_url}/products`, {
    method: "POST",
    body: formData,
  });

  const data = await response.json();

  if(!response.ok){
    throw new Error(data.message || "Upload failed");
  }

  return data;
}

export const fetchProducts = async () =>{
     const response = await fetch(
        `${api_url}/products`
     );
     const data = await response.json();
     if(!response.ok){
        throw new Error(
            data.message || "Failed to fetch products"
        )
     }
     return data.products;
}


export const fetchProductById = async (id) => {
    const response = await fetch(
        `${api_url}/products/${id}`
    );
    const data = await response.json();

    if(!response.ok){
        throw new Error(
            data.message || "Failed to fetch product"
        )
    }

    return data.product;
}

